module.exports = "<div class=\"loans-detail-purposes\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <ul>\n    <li ng-repeat=\"purpose in $ctrl.loan\">\n      {{ purpose.option | capitalizeFirst }}\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansDetail/loansDetailPurposes/loansDetailPurposes.html
// module id = 1838
// module chunks = 0